<template>
  <div class="top-contianer">
    <div class="main_header">
      <h1 class="slogannn" style="color: #00264a;">Vortex Robotics LLC.</h1>
      <b-container>
        <b-row>
          <b-col id="l_s" class="left_slogan">
            <h1 style="color: #00264a;">In thrust</h1>
          </b-col>
          <b-col>
            <img
              id="m_s"
              @click="doSlogan"
              class="slogan_logo"
              src="../../public/img/logos/logo_symm.png"
            />
          </b-col>
          <b-col id="r_s" class="right_slogan">
            <h1 style="color: #00264a;">We trust</h1>
          </b-col>
        </b-row>
      </b-container>
      <br />
      <div class="carousel_container">
        <b-carousel
          id="carousel-2"
          class="main_carousel"
          :interval="3000"
          controls
          indicators
          background="#ababab"
          img-width="800"
          img-height="480"
          style="text-shadow: 1px 1px 2px #333;"
        >
          <router-link
            v-for="header in mainHeaders"
            :key="header.id"
            :index="header.id"
            :to="header.to"
          >
            <b-carousel-slide :img-src="header.path"></b-carousel-slide>
          </router-link>
        </b-carousel>
      </div>

      <div class="grey_strip"></div>
    </div>
    <GearsSep />

    <br />
    <h1 style="color: #00264a; text-align:center;">Our story in a glimpse</h1>
    <h5
      class="justify_align"
    >Established by Technology enthusiasts in 2018, Vortex Robotics succeeded to be the first ROV Manufacturer in the Middle East with its fully created designs and technology to start its renovation in the underwater world and provide innovative solutions for the marine industry.</h5>

    <section class="timeline">
      <div class="container">
        <div v-for="story in stories" :key="story.name" class="timeline-item">
          <div class="timeline-img"></div>
          <div class="timeline-content timeline-card" :class="story.fade">
            <div class="timeline-img-header">
              <b-img-lazy class="timeline-img-header" :src="story.img"></b-img-lazy>
              <h2>{{story.title}}</h2>
            </div>
            <div class="date">{{story.date}}</div>
            <p>
              <br />
              {{story.text}}
            </p>
            <!--<a class="bnt-more" href="javascript:void(0)">More</a>-->
            <br />
          </div>
        </div>
      </div>
      <div class="timeline-end-img"></div>
    </section>
    <div class="main_header">
      <h1 style="color: #00264a;">Our Story in a video</h1>
      <h5 class="justify_align"></h5>
      <div class="grey_strip">Credits go to WAYA team</div>
    </div>
    <GearsSep />
    <br />
    <br />
    <div class="inline">
      <iframe
        src="https://www.facebook.com/plugins/video.php?href=https%3A%2F%2Fwww.facebook.com%2Fwaya.media%2Fvideos%2F2288100131444604%2F&show_text=0&width=380"
        width="340"
        height="476"
        style="border:none;overflow:hidden"
        scrolling="no"
        frameborder="0"
        allowtransparency="true"
        allowfullscreen="true"
      ></iframe>
    </div>
  </div>
</template>

<script>
import GearsSep from "./../components/GearsSep.vue";
export default {
  components: {
    GearsSep
  },
  data() {
    return {
      slide: 0,
      sliding: null,
      mainHeaders: [
        { id: 2, path: "img/carousel/slider1.jpg", to: "/commercial" },
        { id: 3, path: "img/carousel/slider2.jpg", to: "/academy" },
        { id: 4, path: "img/carousel/slider3.jpg", to: "/store" },
        { id: 5, path: "img/carousel/history.jpg", to: "/about_us" }
      ],
      scrolledToTopFlag: false,
      stories: [
        {
          title: "founded",
          img: "img/news/start.jpg",
          date: " 2015 OCTOBER",
          text:
            "Vortex team founded in 2015, by a group of 8 engineering students in Alexandria University compete in various ROV competitions.",
          fade: "js--fadeInLeft"
        },
        {
          title: "First Success",
          img: "img/news/first_success.jpg",
          date: "2017 JUNE",
          text:
            "In 2017 the team succeeded in achieving the third place in MATE international ROV competition.",
          fade: "js--fadeInRight"
        },
        {
          title: "2.0 Generation",
          img: "img/news/first_vep.png",
          date: "2017 SEPTEMBER",
          text:
            "Vortex started it’s VEP program for the first year which resulted by two teams qualified to participate in the ROV competitions (Vortex Juniors and Vortex Titans).With an Outstanding performance by the two teams",
          fade: "js--fadeInLeft"
        },
        {
          title: "The first in the world",
          img: "img/news/first_place.jpg",
          date: "2018 JUNE 22nd",
          text:
            "Vortex Titans achieved the first place in the final competition in Seattle, Washington.",
          fade: "js--fadeInRight"
        },
        {
          title: "UMVC Competition",
          img: "img/news/mtc1.jpg",
          date: "2018 AUGUST 2nd",
          text:
            "Vortex participated in UMVC organized by the Military Technical College. We achieved the 1st and 2nd place by Titans and Juniors respectively.",
          fade: "js--fadeInLeft"
        },
        {
          title: "Vortex Robotics LLC",
          img: "img/logos/vortex.png",
          date: "2018 OCTOBER 1st",
          text:
            "We started to go more through our plan to launch Vortex company as the first Egyptian company specialized in designing and manufacturing the ROV in Egypt with competitive advantage in the global market.",
          fade: "js--fadeInRight"
        },
        {
          title: "MVP",
          img: "img/rovs/vdrax/5.jpg",
          date: "2019 July",
          text:
            "VDrax is the first valuable project, ROV that strikes the commercial field with very suitable cost and professional features.",
          fade: "js--fadeInLeft"
        }
      ]
    };
  },
  methods: {
    doSlogan() {
      if (window.innerWidth > 550 && window.innerWidth < 800) {
        document.getElementById("l_s").style.transform = "translate(20%, 0)";
        setTimeout(() => {
          var i;
          this.doRotation(this, 0);
          setTimeout(
            () =>
              (document.getElementById("r_s").style.transform =
                "translate(-20%, 0)"),
            1300
          );
        }, 700);
      } else if (window.innerWidth > 550) {
        document.getElementById("l_s").style.transform = "translate(85%, 0)";
        setTimeout(() => {
          var i;
          this.doRotation(this, 0);
          setTimeout(
            () =>
              (document.getElementById("r_s").style.transform =
                "translate(-85%, 0)"),
            1300
          );
        }, 700);
      } else {
        document.getElementById("l_s").style.transform = "translate(30%, 0)";
        setTimeout(() => {
          var i;
          this.doRotation(this, 0);
          setTimeout(
            () =>
              (document.getElementById("r_s").style.transform =
                "translate(-30%, 0)"),
            1300
          );
        }, 700);
      }
    },
    doRotation(that, deg) {
      if (deg < 580) {
        document.getElementById("m_s").style.webkitTransform =
          "rotate(" + (deg % 360) * 2 + "deg)";
        document.getElementById("m_s").style.transform =
          "rotate(" + (deg % 360) * 2 + "deg)";
        setTimeout(function() {
          that.doRotation(that, deg + 2);
        });
      }
    }
  },
  mounted() {
    var tabs = document.getElementById("right_nav").querySelectorAll("a");
    for (var i = 0; i < tabs.length; i++) {
      tabs[i].style.color = "#00264a";
    }
    document
      .getElementById("vortexNameImage")
      .setAttribute("src", "img/logos/vortex_name.png");
    $(function() {
      window.sr = ScrollReveal();
      if ($(window).width() < 768) {
        if ($(".timeline-content").hasClass("js--fadeInLeft")) {
          $(".timeline-content")
            .removeClass("js--fadeInLeft")
            .addClass("js--fadeInRight");
        }
        sr.reveal(".js--fadeInRight", {
          origin: "right",
          distance: "300px",
          easing: "ease-in-out",
          duration: 800
        });
      } else {
        sr.reveal(".js--fadeInLeft", {
          origin: "left",
          distance: "300px",
          easing: "ease-in-out",
          duration: 800
        });

        sr.reveal(".js--fadeInRight", {
          origin: "right",
          distance: "300px",
          easing: "ease-in-out",
          duration: 800
        });
      }

      sr.reveal(".js--fadeInLeft", {
        origin: "left",
        distance: "300px",
        easing: "ease-in-out",
        duration: 800
      });

      sr.reveal(".js--fadeInRight", {
        origin: "right",
        distance: "300px",
        easing: "ease-in-out",
        duration: 800
      });
    });
  }
};
</script>

<style lang="scss" scoped>
.top-contianer {
  width: 100%;
}
.tips {
  color: darkgrey;
  width: 50%;
  display: inline-block;
}
.justify_align {
  color: darkgrey;
  width: 50%;
  display: inline-block;
  text-align: center;
}
.inline {
  display: inline-block;
  width: 100%;
}

#table_img {
  transform: rotate(180deg);
}
$secondary: #337be6;
$primary: #337be6;
$dark-primary: #176ae6;
$light-primary: #c5cae9;
$text: #ffffff;
$primary-text: #212121;
$secondary-text: #757575;
$accent: #00264a;

.timeline-end-img {
  width: 50px;
  height: 50px;
  background: $primary;
  border-radius: 50%;
  position: absolute;
  left: 50%;
  margin-top: 25px;
  margin-left: -25px;
}
section {
  padding: 100px 0;
}

html,
body {
  overflow-x: hidden;
}

body {
  font-family: "Roboto";
  font-size: 17px;
  font-weight: 400;
  background-color: #eee;
}

h1 {
  font-size: 200%;
  text-transform: uppercase;
  letter-spacing: 3px;
  font-weight: 400;
}

header {
  background: $primary;
  color: $text;
  padding: 150px 0;

  p {
    font-family: "Allura";
    color: rgba(255, 255, 255, 0.2);
    margin-bottom: 0;
    font-size: 60px;
    margin-top: -30px;
  }
}

.slogan_logo {
  width: 50px;
  height: 50px;
  transition: 0.3s scale ease-in;
  cursor: pointer;
}
.slogan_logo:hover {
  transform: scale(1.1);
}
.grey_strip {
  background: #f2f2f2;
  width: 100%;
  height: 70px;
}
.left_slogan {
  position: relative;
  top: 8px;
  text-align: left;
  transition: 0.7s ease-in-out;
  transform: translate(-140%, 0);
}
.right_slogan {
  position: relative;
  top: 8px;
  text-align: right;
  transition: 0.7s ease-in-out;
  transform: translate(140%, 0);
}

.timeline {
  position: relative;

  &::before {
    content: "";
    background: $light-primary;
    width: 5px;
    height: 95%;
    position: absolute;
    left: 50%;
    transform: translateX(-50%);
  }
}

.timeline-item {
  width: 100%;
  margin-bottom: 70px;

  &:nth-child(even) {
    .timeline-content {
      float: right;
      padding: 40px 30px 10px 30px;

      .date {
        right: auto;
        left: 0;
      }

      &::after {
        content: "";
        position: absolute;
        border-style: solid;
        width: 0;
        height: 0;
        top: 30px;
        left: -15px;
        border-width: 10px 15px 10px 0;
        border-color: transparent #f5f5f5 transparent transparent;
      }
    }
  }

  &::after {
    content: "";
    display: block;
    clear: both;
  }
}

.timeline-content {
  position: relative;
  width: 45%;
  padding: 10px 30px;
  border-radius: 4px;
  background: #f5f5f5;
  box-shadow: 0 20px 15px -15px rgba(0, 0, 0, 0.3);

  &::after {
    content: "";
    position: absolute;
    border-style: solid;
    width: 0;
    height: 0;
    top: 30px;
    right: -15px;
    border-width: 10px 0 10px 15px;
    border-color: transparent transparent transparent #f5f5f5;
  }
}
.main_carousel {
  width: 90%;
  display: inline-block;
  overflow: hidden;
  border-radius: 15px;
  position: relative;
}
.carousel_container {
  position: relative;

  width: 90%;
  display: inline-block;
  /*padding-top: 80px;*/
  padding-bottom: 30px;
  opacity: 1;
  -webkit-animation: fadein 2s; /* Safari, Chrome and Opera > 12.1 */
  -moz-animation: fadein 2s; /* Firefox < 16 */
  -ms-animation: fadein 2s; /* Internet Explorer */
  -o-animation: fadein 2s; /* Opera < 12.1 */
  animation: fadein 2s;
}

.slide {
  left: 0px !important;
}

.timeline-img {
  width: 30px;
  height: 30px;
  background: $primary;
  border-radius: 50%;
  position: absolute;
  left: 50%;
  margin-top: 25px;
  margin-left: -15px;
}

.timeline a {
  background: $primary;
  color: $text;
  padding: 8px 20px;
  text-transform: uppercase;
  font-size: 14px;
  margin-bottom: 20px;
  margin-top: 10px;
  display: inline-block;
  border-radius: 2px;
  box-shadow: 0 1px 3px -1px rgba(0, 0, 0, 0.6);

  &:hover,
  &:active,
  &:focus {
    background: darken($primary, 10%);
    color: $text;
    text-decoration: none;
  }
}

.timeline-card {
  padding: 0 !important;

  p {
    padding: 0 20px;
  }

  a {
    margin-left: 20px;
  }
}

.timeline-item {
  .timeline-img-header {
    background: linear-gradient(rgba(0, 0, 0, 0), rgba(0, 0, 0, 0.4));
    background-size: cover !important;
    opacity: 0.98;
  }
}

.timeline-img-header {
  width: 100%;
  position: relative;

  h2 {
    text-shadow: 2px 2px #00264a;
    /*color: $text;*/
    color: #f5f5f5;
    position: absolute;
    bottom: 5px;
    left: 20px;
  }
}

blockquote {
  margin-top: 30px;
  color: $secondary-text;
  border-left-color: $primary;
  padding: 0 20px;
}

.date {
  width: 35%;
  height: 38px;
  overflow: hidden;
  background: rgba(0, 38, 74, 0.8);
  display: inline-block;
  color: $text;
  padding: 10px;
  position: absolute;
  top: 0;
  right: 0;
}

@media screen and (max-width: 768px) {
  .slogannn {
    font-size: 150%;
  }
  .timeline {
    &::before {
      left: 50px;
    }
    .timeline-img {
      left: 50px;
    }
    .timeline-end-img {
      left: 50px;
      margin-top: -10px;
    }
    .timeline-content {
      max-width: 100%;
      width: auto;
      margin-left: 70px;
    }

    .timeline-item {
      &:nth-child(even) {
        .timeline-content {
          float: none;
        }
      }

      &:nth-child(odd) {
        .timeline-content {
          &::after {
            content: "";
            position: absolute;
            border-style: solid;
            width: 0;
            height: 0;
            top: 30px;
            left: -15px;
            border-width: 10px 15px 10px 0;
            border-color: transparent #f5f5f5 transparent transparent;
          }
        }
      }
    }
  }
}
@media screen and (max-width: 500px) {
  .tips {
    width: 90%;
  }
}
</style>
